import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/modules/shared/shared.module";
import { ActivateAccountComponent } from "./activate-account.component";
import { TranslocoModule } from "@jsverse/transloco";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ClickableDirective } from "src/app/modules/shared/directives/clickable.directive";

@NgModule({
  declarations: [ActivateAccountComponent],
  imports: [ClickableDirective, CommonModule, SharedModule, MatProgressSpinnerModule, TranslocoModule],
})
export class ActivateAccountModule {}
